export default "__VITE_ASSET__CkVu$_i3__"